import React from 'react'
import "../ChatBox/ChatBox.scss"

interface TopicListProp {
    conversationId: string;
    topics?: any;
     onTopicClick?: (conversationId: string, topicTitle: string,description: string,subject?:string) => void;
     handleShowChat: (showTopic: boolean) => void;
     confirmDetails: any;
     onTopicSelected: () => void;
}

const TopicList: React.FC<TopicListProp> = ({ conversationId , topics,onTopicClick  , handleShowChat, confirmDetails, onTopicSelected }) => {
    return (
        <div className='view-top-card-wrapper'>
            {/* <div className="label-topics">View Topics</div> */}
            <div className="topic-card-row">
                {topics?.topics && topics?.topics.map((topic : any , index : any ) => (
                    <div 
                    className={`topic-card ${(topic.title === confirmDetails?.topic) ? "selected" : ""}`}
                    key={index} 
                      onClick={() => {onTopicClick?.(conversationId, topic?.title,topic?.description,topic?.subject); onTopicSelected()}}
                    >
                        <div className="topic-name">{topic?.title}</div>
                        <div className="topic-dsc">{topic?.description}</div>
                    </div>
                ))}
                 {/* <div className="topic-card" onClick={() => handleShowChat(false)}>
                        <div className="topic-name">Enter your topic</div>
                        <div className="topic-dsc">Type any topic in chat</div>
                    </div> */}
            </div>
        </div>
    )
}

export default TopicList